import type { ApiParamsDefinition } from '@/api/types/api-definition';
import type {
  CartCheckRequest,
  CartDeleteRequest,
  CartFreeShippingRequest,
  CartPriceRequest,
  CartUpdateRequest,
  IgStoreCartRequest,
  AddCartParams,
} from '@/api/types/cart';

import { httpRequest, request } from '../request';
type PointMallCartListRequest =
  ApiParamsDefinition['GET:/api/customer/cart/point_mall_list']['params'];

type CartUpdateConfig = {
  errorMsg?: boolean;
  successMsg?: boolean;
  msgType?: 'default' | 'box';
  duration?: number;
  isEncrypt?: boolean;
  canRepeated?: boolean;
  headers?: unknown;
  timeout?: number;
};

export default {
  addCart: (data: AddCartParams) => httpRequest('POST:/api/cart/store', { data }),
  cartList: () => httpRequest('GET:/api/cart/lists'),
  // 积分商城购物车列表（只会有一条）
  pointMallCartList: (data: PointMallCartListRequest) =>
    httpRequest('GET:/api/customer/cart/point_mall_list', { params: data }),
  updateCart: (data: CartUpdateRequest, msgConfig?: CartUpdateConfig) =>
    httpRequest('PUT:/api/cart/update', { data }, msgConfig), // 更新购物车中处方和数量和商品
  deleteCart: (data: CartDeleteRequest) => httpRequest('DELETE:/api/cart/delete', data),
  getCartPrice: (data: CartPriceRequest, msgConfig = { successMsg: false, errorMsg: true }) =>
    httpRequest('POST:/api/cart/get_cart_price', { data }, msgConfig),
  getCartColorList: (data: any) => request('/api/cart/get_same_spu_products', 'get', data),
  freePolicy: (data: CartFreeShippingRequest) =>
    httpRequest('GET:/api/cart/free_shipping_policy', { params: data }),
  check: (data: CartCheckRequest) =>
    httpRequest('POST:/api/cart/check', { data }, { errorMsg: false }), // 购物车跳转结算页面前检查
  igStoreCart: (data: IgStoreCartRequest) => httpRequest('POST:/api/cart/ig_store', { data }), // igStore 批量加购接口（从ig小店跳转过来）
};
